import Icon from '../components/Icon.vue'

Icon.register({
  'long-arrow-alt-right': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M313.9 216v-46.1c0-21.4 25.9-32.1 41-17l86.1 86.1c9.4 9.4 9.4 24.6 0 33.9l-86.1 86.1c-15.1 15.1-41 4.4-41-17v-46.1h-301.9c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h301.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/long-arrow-alt-right.js
// module id = 1534
// module chunks = 0